import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import { GraphQLClient} from "graphql-request";

import Login from "./LoginPanel.jsx";
import { graphqlEndpoint } from "../config.js";

import { READ_TENANT_LOGIN_BRANDING_BY_SLUG } from "../graph/tenants/queries";

const client = new GraphQLClient(graphqlEndpoint);


const TenantLoginPage = () => {
  const { tenantSlug } = useParams();
  const [tenantBranding, setTenantBranding] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchTenantBranding = async () => {
      try {
        const data = await client.request(READ_TENANT_LOGIN_BRANDING_BY_SLUG, {
          slug: tenantSlug,
        });

        setTenantBranding(data.readTenantLoginBrandingBySlug);
      } catch (err) {
        console.error("Failed to fetch tenant branding:", err);
        setError("This login page could not be found.");
      } finally {
        setLoading(false);
      }
    };

    fetchTenantBranding();
  }, [tenantSlug]);

  if (loading) {
    return <Box p={4}>Loading...</Box>;
  }

  if (error) {
    return (
      <Box p={4}>
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  return <Login tenantBranding={tenantBranding} />;
};

export default TenantLoginPage;